/**
 * Formato es-ES de la Tienda. Moneda siempre con céntimos y separador de miles
 * (1.219,00 €). La fecha es 28/10/2026 y, si lleva hora, 28/10/2026 22:04.
 */

const GROUPING_SPACE = /[\u00a0\u202f]/g;

const currencyFormatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
});

const inputFormatter = new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false,
});

const dateFormatter = new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});

const timeFormatter = new Intl.DateTimeFormat('es-ES', {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
});

function asNumber(value: number | null | undefined): number | null {
    if (value == null || !Number.isFinite(Number(value))) return null;
    return Number(value);
}

function asDate(value: Date | string | null | undefined): Date | null {
    if (value == null || value === '') return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatNumber(
    value: number | null | undefined,
    fractionDigits?: number,
): string {
    const n = asNumber(value);
    if (n == null) return '—';
    const options: Intl.NumberFormatOptions = { useGrouping: true };
    if (fractionDigits != null) {
        options.minimumFractionDigits = fractionDigits;
        options.maximumFractionDigits = fractionDigits;
    }
    return new Intl.NumberFormat('es-ES', options).format(n);
}

export function formatEur(amount: number | null | undefined): string {
    const n = asNumber(amount);
    if (n == null) return '—';
    return currencyFormatter.format(n).replace(GROUPING_SPACE, ' ');
}

export function formatEurFromCents(cents: number | null | undefined): string {
    const n = asNumber(cents);
    if (n == null) return '—';
    return formatEur(n / 100);
}

/** Importe editable, con coma decimal y sin separador de miles (el parser lo acepta). */
export function formatEurInput(amount: number): string {
    if (!Number.isFinite(amount)) return '';
    return inputFormatter.format(amount);
}

export function formatDate(value: Date | string | null | undefined): string {
    const date = asDate(value);
    if (!date) return '—';
    return dateFormatter.format(date);
}

export function formatDateTime(value: Date | string | null | undefined): string {
    const date = asDate(value);
    if (!date) return '—';
    return `${dateFormatter.format(date)} ${timeFormatter.format(date)}`;
}
